function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
var TradeOverlayTemplate = require('./trade.template');
var SaitoOverlay = require('./../../../../../lib/saito/ui/saito-overlay/saito-overlay');
var TradeOverlay = /*#__PURE__*/function () {
  function TradeOverlay(app, mod) {
    _classCallCheck(this, TradeOverlay);
    this.app = app;
    this.mod = mod;
    this.overlay = new SaitoOverlay(this.app, this.mod, false);
    this.tradeType = -1; // trade with everyone, or playerNum
    this.get = {};
    this.give = {};
    this.offering_player = 0;
    this.accepting_trade = 0;
    this.resources = null;
    this.should_clear_advert = false;
  }
  return _createClass(TradeOverlay, [{
    key: "initialize",
    value: function initialize() {
      this.resources = this.mod.returnResources();
      var _iterator = _createForOfIteratorHelper(this.resources),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var r = _step.value;
          console.log(r);
          this.get[r] = 0;
          this.give[r] = 0;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      this.accepting_trade = 0;
      this.should_clear_advert = false;
    }
  }, {
    key: "render",
    value: function render() {
      var reset = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
      if (reset) {
        this.initialize();
      }
      if (!this.resources) {
        this.resources = this.mod.returnResources();
      }

      // Since this.accepting_trade gets untoggled, if we change the offer
      if (this.accepting_trade) {
        this.should_clear_advert = true;
      }
      this.overlay.show(TradeOverlayTemplate(this));
      this.attachEvents();
    }
  }, {
    key: "attachEvents",
    value: function attachEvents() {
      var _this = this;
      var trade_overlay = this;
      var settlers_self = this.mod;
      document.querySelectorAll('.trade_count_up').forEach(function (arrow) {
        arrow.onclick = function (e) {
          trade_overlay.accepting_trade = 0;
          document.querySelector('.trade_overlay_button').innerHTML = 'Broadcast Offer';
          var item = e.currentTarget.parentElement.getAttribute('id');
          var temp = item.split('_');
          var resname = temp[1];
          if (temp[0] == 'want') {
            _this.get[resname]++;
          } else {
            //
            // cannot offer more than you have
            //
            if (_this.give[resname] < settlers_self.countResource(settlers_self.game.player, resname)) {
              _this.give[resname]++;
            }
          }
          _this.render(false);
        };
      });
      document.querySelectorAll('.trade_count_down').forEach(function (arrow) {
        arrow.onclick = function (e) {
          trade_overlay.accepting_trade = 0;
          document.querySelector('.trade_overlay_button').innerHTML = 'Broadcast Offer';
          var item = e.currentTarget.parentElement.getAttribute('id');
          var temp = item.split('_');
          var resname = temp[1];
          if (temp[0] == 'want') {
            if (_this.get[resname] > 0) {
              _this.get[temp[1]]--;
            }
          } else {
            if (_this.give[temp[1]] > 0) {
              _this.give[temp[1]]--;
            }
          }
          _this.render(false);
        };
      });
      $('#trade_overlay_broadcast_button').off();
      $('#trade_overlay_broadcast_button.valid_trade').on('click', function () {
        $('#trade_overlay_broadcast_button').off();
        if (trade_overlay.should_clear_advert) {
          settlers_self.addMove("clear_advert\t".concat(trade_overlay.offering_player));
        }
        if (trade_overlay.accepting_trade == 0) {
          settlers_self.addMove("offer\t".concat(settlers_self.game.player, "\t").concat(trade_overlay.tradeType, "\t").concat(JSON.stringify(trade_overlay.give), "\t").concat(JSON.stringify(trade_overlay.get)));
          settlers_self.endTurn();
          trade_overlay.overlay.close();
        } else {
          settlers_self.addMove("accept_offer\t".concat(trade_overlay.offering_player, "\t").concat(settlers_self.game.player, "\t").concat(JSON.stringify(trade_overlay.give), "\t").concat(JSON.stringify(trade_overlay.get)));
          settlers_self.endTurn();
          trade_overlay.overlay.close();
        }
      });
      $("#trade_overlay_cancel_button").off();
      $("#trade_overlay_cancel_button").on('click', function () {
        $("#trade_overlay_cancel_button").off();
        if (trade_overlay.offering_player == 0) {
          trade_overlay.overlay.close();
          return;
        }
        if (trade_overlay.offering_player == settlers_self.game.player) {
          settlers_self.addMove("clear_advert\t".concat(settlers_self.game.player));
        } else {
          settlers_self.addMove("reject_offer\t".concat(settlers_self.game.player, "\t").concat(trade_overlay.offering_player));
        }
        settlers_self.endTurn();
        trade_overlay.overlay.close();
      });
    }
  }]);
}();
module.exports = TradeOverlay;